module.exports = __webpack_public_path__ + "static/media/bed-empty.b5925291.svg";